// frontend/src/components/CrearEditarProveedorModal.jsx
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { toast } from 'react-toastify';
import { FiX, FiSave } from 'react-icons/fi';
import { proveedorService } from '../services/onebaseService';
import './CrearModal.css';

const CrearEditarProveedorModal = ({ proveedor, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    rut: '',
    contacto_principal: '',
    email: '',
    telefono: '',
    direccion: '',
    status: 'activo'
  });

  useEffect(() => {
    if (proveedor) {
      setFormData({
        nombre: proveedor.nombre || '',
        rut: proveedor.rut || '',
        contacto_principal: proveedor.contacto_principal || '',
        email: proveedor.email || '',
        telefono: proveedor.telefono || '',
        direccion: proveedor.direccion || '',
        status: proveedor.status || 'activo'
      });
    }
  }, [proveedor]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (proveedor) {
        // Actualizar proveedor existente
        await proveedorService.update(proveedor.id, formData);
        toast.success('Proveedor actualizado correctamente');
      } else {
        // Crear nuevo proveedor
        await proveedorService.create(formData);
        toast.success('Proveedor creado correctamente');
      }
      onSuccess();
    } catch (error) {
      console.error('Error al guardar proveedor:', error);
      toast.error(proveedor ? 'Error al actualizar el proveedor' : 'Error al crear el proveedor');
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '800px' }}>
        <div className="modal-header">
          <h2>{proveedor ? 'Editar Proveedor' : 'Nuevo Proveedor'}</h2>
          <button className="close-btn" onClick={onClose}>
            <FiX />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-section">
            <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '15px' }}>
              <div className="form-group">
                <label>Nombre *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleInputChange}
                  required
                  placeholder="Nombre del proveedor"
                />
              </div>

              <div className="form-group">
                <label>RUT</label>
                <input
                  type="text"
                  name="rut"
                  value={formData.rut}
                  onChange={handleInputChange}
                  placeholder="12.345.678-9"
                />
              </div>
            </div>

            <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div className="form-group">
                <label>Contacto Principal</label>
                <input
                  type="text"
                  name="contacto_principal"
                  value={formData.contacto_principal}
                  onChange={handleInputChange}
                  placeholder="Nombre del contacto"
                />
              </div>

              <div className="form-group">
                <label>Teléfono</label>
                <input
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleInputChange}
                  placeholder="+56 9 1234 5678"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="contacto@proveedor.com"
              />
            </div>

            <div className="form-group">
              <label>Dirección</label>
              <textarea
                name="direccion"
                value={formData.direccion}
                onChange={handleInputChange}
                rows="3"
                placeholder="Dirección completa del proveedor"
              />
            </div>

            <div className="form-group">
              <label>Estado</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleInputChange}
              >
                <option value="activo">Activo</option>
                <option value="inactivo">Inactivo</option>
              </select>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn-primary" disabled={loading}>
              <FiSave /> {loading ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default CrearEditarProveedorModal;
